export default defineNuxtPlugin(() => {
  return {
    provide: {
      useIsExternalUrl,
      useIsRouterLinkActive,
    },
  }
})
